import type { CustomAxiosInstance, CustomConfig, CustomResponse } from './IUseAxios'
import { createErrorHandler } from './errorHandler'
import { loadingController } from './loading'

/**
 * Setup request interceptors
 */
export const setupRequestInterceptors = (axiosInstance: CustomAxiosInstance): void => {
    axiosInstance.interceptors.request.use(
        (config: CustomConfig) => {
            if (!config.noLoading) {
                loadingController.addProcessApi(config.url ?? '')
            }
            return config
        },
        (error) => {
            const url = error.config?.url ?? ''
            loadingController.deleteProcessApi(url)
            return Promise.reject(error)
        },
    )
}

/**
 * Setup response interceptors
 */
export const setupResponseInterceptors = (axiosInstance: CustomAxiosInstance): void => {
    const errorHandler = createErrorHandler()

    axiosInstance.interceptors.response.use(
        (response: CustomResponse) => {
            if (!response.config.noLoading) {
                loadingController.deleteProcessApi(response.config.url ?? '')
            }
            return response
        },
        (error) => {
            const url = error.response?.config?.url ?? ''
            loadingController.deleteProcessApi(url)
            return errorHandler(error)
        },
    )
}
